import React, {useEffect} from "react";

export default function FormCheckbox({label, name, errors, onChange, value, groupClassName = '', className = '', required = false, disabled = false, readOnly = false, autoComplete = 'off', autoFocus = false, hint = ''}) {
    const [localValue, setLocalValue] = React.useState(!!value);
    const [uuid, setUuid] = React.useState('');


    useEffect(() => {
        if (!uuid) {
            setUuid(Math.random().toString(36).substring(7));
        }
    }, []);


    useEffect(() => {
        let newValue = true;
        if (value === undefined || value === null || !value) {
            newValue = false;
        }

        setLocalValue(newValue);
    }, [value]);


    const onFieldChange = (e) => {
        e.preventDefault();
        e.stopPropagation();

        onChange(!localValue);
        setLocalValue(!localValue);
    }


    return (
        <>
            <div className={'form-check form-check-inline ' + groupClassName}>
                <input className="form-check-input" type="checkbox" id={'cf-' + uuid} name={'cf-' + uuid} checked={localValue} onChange={(e) => {e.preventDefault();
        e.stopPropagation();}} onClick={onFieldChange} />
                <label className="form-check-label" htmlFor={'cf-' + uuid} onClick={onFieldChange}>{label}</label>
            </div>
            {(hint || errors && errors[name]) ? (
            <div className="d-flex justify-content-between gap-3 mt-1">
                {hint && (<div className={'flex-grow-1 text-start fs-2'}>{hint}</div>)}
                {errors && errors[name] && <div className="form-text text-danger">{errors[name].join(' ')}</div>}
            </div>
            ) : null }
        </>
    )
}
